import {ACTION_CODE} from './_actionCode';
import {ContractorService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DELETE_CONTRACTORS';

export async function deleteContractor(
    userData: Record<string, string>,
    contractorId: number
) {
    try {
        LoggerService.logInfo('Action - deleteContractor - Start');

        const deleteContractorResult = await ContractorService.deleteContractor(userData, contractorId);

        LoggerService.logInfo('Action - deleteContractor - End - Success');

        return ResultModel.newSuccessResult(deleteContractorResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - deleteContractor - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression du client.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
